/* unplugin-vue-components disabled */import { render } from "./honorMedal.vue?vue&type=template&id=07aa896f&scoped=true"
import script from "./honorMedal.vue?vue&type=script&lang=js"
export * from "./honorMedal.vue?vue&type=script&lang=js"

import "./honorMedal.vue?vue&type=style&index=0&id=07aa896f&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07aa896f"]])

export default __exports__